/**
 * How many seed domains a lookalike company search takes (a positive count).
 *
 * The lookalike seed card and the onboarding's lookalike step stop at it, and the MCP tool
 * `create_list_from_lookalike_companies` refuses more (PREC-4374), so the web and the API apply
 * one number.
 */
export const MAX_LOOKALIKE_DOMAINS = 10;
